import { render } from "./financialStats-2023.vue?vue&type=template&id=5c416084&scoped=true"
import script from "./financialStats-2023.vue?vue&type=script&lang=js"
export * from "./financialStats-2023.vue?vue&type=script&lang=js"

import "./financialStats-2023.vue?vue&type=style&index=0&id=5c416084&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c416084"]])

export default __exports__